export default "__VITE_ASSET__DywBRhCr__"